<template>
  <div>
    <div>
      <div v-if="company">
        <div class="mt--2">
          <b-card no-body>
            <b-row class="pt-4 pl-2 m-0 gray-bg">
              <b-col col="6">
                <h3>{{ company.companyName }}</h3>
              </b-col>
              <b-col col="6" class="text-right pr-4">
                <b-button
                  variant="success"
                  href="#"
                  @click.prevent="login(company.id)"
                  ><i class="fa-solid fa-circle-arrow-up-right"></i
                ></b-button>
              </b-col>
            </b-row>

            <b-tabs card v-model="tabIndex">
              <b-tab title="Company Contact" lazy>
                <validation-observer
                  ref="formValidator"
                  v-slot="{ handleSubmit }"
                >
                  <b-form
                    role="form"
                    @submit.prevent="handleSubmit(submitCompany)"
                  >
                    <div class="p-5">
                      <b-row>
                        <b-col>
                          <b-card class="border shadow-sm p-5 m-0">
                            <base-input
                              label="Name"
                              name="Company Name"
                              v-model="company.companyName"
                              rules="required"
                            ></base-input>

                            <base-input
                              label="Address"
                              v-model="company.address1"
                            ></base-input>

                            <base-input v-model="company.address2"></base-input>

                            <b-row>
                              <b-col>
                                <base-input
                                  label="City"
                                  v-model="company.city"
                                ></base-input>
                              </b-col>
                              <b-col>
                                <base-input
                                  v-model="company.state"
                                  label="State"
                                ></base-input>
                              </b-col>
                              <b-col>
                                <base-input
                                  v-model="company.zipCode"
                                  label="Zip Code"
                                ></base-input>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                <base-input
                                  v-model="company.email"
                                  label="Email"
                                  rules="required|email"
                                ></base-input>
                              </b-col>
                              <b-col>
                                <base-input-phone
                                  v-model="company.phoneNumber"
                                  label="Phone Number"
                                  rules="phoneNumber"
                                  name="Phone Number"
                                ></base-input-phone>
                              </b-col>
                            </b-row>

                            <div class="form-control-label">
                              Time Zone
                            </div>
                            <b-form-select
                              label="Time Zone"
                              v-model="company.timeZoneIndex"
                              :options="company.timeZones"
                              class="form-control mt-2"
                            ></b-form-select>

                            <b-form-checkbox
                              switch
                              class="mt-3"
                              size="sm"
                              v-model="company.isActive"
                              >Active</b-form-checkbox
                            >
                          </b-card>
                        </b-col>
                        <b-col>
                          <b-card class="border shadow-sm p-5 m-0">
                            <template #modal-header>
                              <h2>Branding</h2>
                            </template>
                            <b-row>
                              <b-col>
                                <UploadImage
                                  :imageUrl="company.companyImageUrl"
                                  @url="imageUrlUpdated"
                                  :width="company.widthPx"
                                />
                              </b-col>
                              <b-col>
                                <div class="form-control-label pb-2">
                                  Hex Color
                                </div>
                                <base-input
                                  v-model="company.linkHexColor"
                                  prependChar="#"
                                  rules="required"
                                >
                                </base-input>

                                <div class="form-control-label pb-2">Width</div>
                                <base-input
                                  v-model="company.widthPx"
                                  rules="required"
                                >
                                </base-input>
                              </b-col>
                            </b-row>
                          </b-card>

                          <b-card class="border shadow-sm p-5 m-0 mt-4">
                            <div class="form-control-label">
                              System
                            </div>
                            <b-select
                              :options="company.systems"
                              v-model="company.systemId"
                            ></b-select>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-button
                        type="submit"
                        class="btn btn-block mt-3"
                        variant="primary"
                        >Submit</b-button
                      >
                    </div>
                  </b-form>
                </validation-observer>
              </b-tab>

              <b-tab title="Users" lazy>
                <div class="p-5">
                  <manage-users
                    :bindUsers="bindUsers"
                    :userUpdated="userUpdated"
                    :bindRoles="bindRoles"
                  ></manage-users>
                </div>
              </b-tab>
              <b-tab title="Settings" lazy>
                <div class="pt-5">
                  <settings
                    :company="company"
                    :bindReceiptSettings="bindReceiptSettings"
                    @updateReceiptSettings="updateReceiptSettings"
                    :bindMembershipSettings="bindMembershipSettings"
                    @updateMembershipSettings="updateMembershipSettings"
                    :bindPaymentPlanSettings="bindPaymentPlanSettings"
                    @updatePaymentPlanSettings="updatePaymentPlanSettings"
                    :bindOpenDentalSettings="bindOpenDentalSettings"
                    @updateOpenDentalSettings="updateOpenDentalSettings"
                    :bindPaymentPageSettings="bindPaymentPageSettings"
                    :updatePaymentPageSettings="updatePaymentPageSettings"
                    :sendPaymentPageEmail="sendPaymentPageEmail"
                  ></settings>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Settings from "@/views/Components/Company/Settings";
import UploadImage from "@/views/Components/UploadImage";
import ManageUsers from "@/views/Components/User/ManageUsers";

export default {
  title: "Your Company",
  components: {
    "manage-users": ManageUsers,
    UploadImage,
    Settings,
  },
  inject: ["companyService"],
  data() {
    return {
      editTunnelKey: false,
      active: true,
      apiKey: null,
      companyId: null,
      company: null,
      users: null,
      user: null,
      image: null,
      clientId: null,
      selected: null,
      userState: "list",
      widthPx: 75,
      file1: {},
      intervalId: null,
      htmlFile: null,

      baseUrl: process.env.VUE_APP_API,
      gateways: [],
      timeZones: [],
      gateway: null,
      paymentPageSaved: true,
    };
  },
  async mounted() {
    this.companyId = this.$route.params.id;
    this.getData();
  },
  watch: {
    file1: function(val) {
      var self = this;
      this.htmlFile = document.querySelector("#file").files[0];
      this.getBase64(this.htmlFile, (base64) => {
        self.company.companyImage = base64;
      });
    },
  },

  methods: {
    async sendPaymentPageEmail(pp) {
      let r = await this.$client.post("/api/company/sendPaymentPageEmail", pp);
      return r.data.isSuccess;
    },
    async bindMembershipSettings() {
      let r = await this.$client.get(
        "/api/company/getMembershipSettings?companyId=" + this.company.id
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async bindReceiptSettings() {
      let r = await this.$client.get(
        "/api/company/getReceiptSettings?companyId=" + this.company.id
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async bindPaymentPageSettings() {
      let r = await this.$client.get(
        "/api/company/getPaymentPageSettings?companyId=" + this.company.id
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async bindRoles() {
      let r = await this.$client.get(
        "/api/user/getSystemRoles?companyId=" + this.company.id
      );
      if (r.data.isSuccess) return r.data.value.roles;
    },
    async bindOpenDentalSettings() {
      let r = await this.$client.get(
        "/api/company/getOpenDentalSettings?companyId=" + this.company.id
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async bindPaymentPlanSettings() {
      let r = await this.$client.get(
        "/api/company/getPaymentPlanSettings?companyId=" + this.company.id
      );
      if (r.data.isSuccess) return r.data.value;
    },
    showUpload() {
      this.$refs.uploadModal.show();
    },

    imageUrlUpdated(url) {
      this.company.companyImageUrl = url;
    },

    async updatePaymentPlanSettings(paymentPlanSettings) {
      paymentPlanSettings.companyId = this.companyId;
      let r = await this.$client.post(
        "/api/company/updatePaymentPlanSettings",
        paymentPlanSettings
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Payment Plan Settings Updated",
        });
      }
    },
    async updateOpenDentalSettings(openDentalSettings) {
      openDentalSettings.companyId = this.companyId;
      let r = await this.$client.post(
        "/api/company/updateOpenDentalSettings",
        openDentalSettings
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Open Dental Settings Updated",
        });
      }
    },
    async updateMembershipSettings(membershipSettings) {
      membershipSettings.companyId = this.companyId;
      let r = await this.$client.post(
        "/api/company/updateMembershipSettings",
        membershipSettings
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Membership Settings Updated",
        });
      }
    },
    async updatePaymentPageSettings(pp) {
      let r = await this.$client.post("/api/company/updatePaymentPage", pp);
      return r.data.isSuccess;
    },
    async login(companyId) {
      await this.companyService.loginUnderCompany(companyId);
    },

    async rebind() {
      await this.getUsers();
    },

    getData() {
      this.getCompany();
    },
    async cancelUser() {
      this.showUserList();
    },
    newUser() {
      this.user = {
        isActive: true,
        notifyUser: true,
      };
      this.userState = "edit";
    },

    async bindUsers(isActive) {
      var r = await this.$client.get(
        "/api/user/users?companyId=" + this.companyId + "&isActive=" + isActive
      );
      if (r.data.isSuccess) {
        return {
          users: r.data.value.users,
          availableRoles: r.data.value.availableRoles,
        };
      }
    },
    async getCompany(id) {
      var r = await this.$client.get(
        "/api/company/company?companyId=" + this.companyId
      );
      this.company = r.data.value;
    },

    async userUpdated(user) {
      var self = this;

      user.companyId = this.companyId;

      let response = await this.$client.post("/api/user/upsertUser", user);

      if (response.data.isSuccess) {
        if (!user.id)
          self.$emitter.emit("success", {
            title: "Added",
            message: "The user has been added.",
          });
        else
          self.$emitter.emit("success", {
            title: "Updated",
            message: "User has been updated.",
          });
      }
    },

    async updateReceiptSettings(settings) {
      settings.companyId = this.companyId;

      var r = await this.$client.post(
        "/api/company/updateReceiptSettings",
        settings
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Receipt Settings Updated",
        });
      }
    },

    async submitCompany() {
      var self = this;

      if (!this.company.companyImageUrl) {
        this.$emitter.emit("error", "You must upload an image");
        return;
      }

      let r = await this.$client.post(
        "/api/company/updateCompany",
        this.company
      );

      if (r.data.isSuccess) {
        self.$emitter.emit("success", {
          title: "Updated",
          message: "Company has been updated.",
        });
      }
    },
  },
};
</script>

<style scoped>
.card-body {
  padding: 0;
  margin: 0;
}
.options {
  padding: 10px;
}
</style>
